import React from 'react';

import i18n from '@client/utils/i18n';
import { Description, LediumForm, ShowIntensityValue, TitleAndDescription, UniqueName } from '@ledium/ui-common';
import { Box, Button, Container, Grid, Typography } from '@mui/material';

import DmxChannel from './Components/DmxChannel';
import LightChannelChart from './Components/LightChannelChart';
import LightChannelCsvUploadButton from './Components/LightChannelCsvUploadButton';
import MoveZoneDialog from './Components/MoveZoneDialog';
import ResolutionSelector from './Components/ResolutionSelector';

interface LightChannelsViewProps {
    onClose: () => void;
    onSave: () => void;
    onMoveZone?: (newZoneId: string, newZoneName: string) => Promise<void>;
    currentZoneId?: string | null;
    currentZoneName?: string;
}

const LightChannelsView = ({ onClose, onSave, onMoveZone, currentZoneId, currentZoneName }: LightChannelsViewProps) => {
    const [moveZoneOpen, setMoveZoneOpen] = React.useState(false);

    return (
        <Container fixed>
            <LediumForm onSubmit={() => onSave()} onCancel={onClose} header={<TitleAndDescription />}>
                <UniqueName />
                <Description />
                {onMoveZone && (
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography>
                                {i18n('zone')}: <strong>{currentZoneName ?? '—'}</strong>
                            </Typography>
                            <Button size="small" onClick={() => setMoveZoneOpen(true)}>
                                {i18n('change')}
                            </Button>
                        </Box>
                        <MoveZoneDialog
                            open={moveZoneOpen}
                            onClose={() => setMoveZoneOpen(false)}
                            currentZoneId={currentZoneId ?? null}
                            currentZoneName={currentZoneName ?? ''}
                            onConfirm={async (id, name) => {
                                await onMoveZone(id, name);
                                setMoveZoneOpen(false);
                            }}
                        />
                    </Grid>
                )}
                <ResolutionSelector />
                <ShowIntensityValue />
                <DmxChannel />
                <LightChannelCsvUploadButton />
                <LightChannelChart />
            </LediumForm>
        </Container>
    );
};

export default React.memo(LightChannelsView);
